import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

interface StageSelectionProps {
  value?: string;
  onChange: (stage: string) => void;
  error?: string;
}

const stages = [
  {
    value: 'Beginner',
    titleKey: 'stageBeginner',
    descriptionKey: 'stageBeginnerDesc',
    icon: '🌱'
  },
  {
    value: 'Have Idea',
    titleKey: 'stageHaveIdea',
    descriptionKey: 'stageHaveIdeaDesc',
    icon: '💡'
  },
  {
    value: 'In Progress',
    titleKey: 'stageInProgress',
    descriptionKey: 'stageInProgressDesc',
    icon: '🚀'
  }
];

const StageSelection: React.FC<StageSelectionProps> = ({
  value,
  onChange,
  error
}) => {
  const { t } = useLanguage();
  
  return (
    <div className="stage-selection">
      <p className="selection-description">
        {t('journey.stageSelectionPrompt')}
      </p>
      
      <div className="stage-options">
        {stages.map((stage) => (
          <div
            key={stage.value}
            className={`stage-option ${value === stage.value ? 'selected' : ''}`}
            onClick={() => onChange(stage.value)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onChange(stage.value);
              }
            }}
          >
            <div className="stage-icon">{stage.icon}</div>
            <div className="stage-content">
              <h4 className="stage-title">{t(`journey.${stage.titleKey}`)}</h4>
              <p className="stage-description">{t(`journey.${stage.descriptionKey}`)}</p>
            </div>
            <div className="stage-radio">
              <input
                type="radio"
                name="stage"
                value={stage.value}
                checked={value === stage.value}
                onChange={() => onChange(stage.value)}
                tabIndex={-1}
              />
            </div>
          </div>
        ))}
      </div>
      
      {error && (
        <div className="error-message" role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

export default StageSelection;